/*
 * Module for the topics using category modal
 */

define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "underscore",
  "./topicsUsingCategoryModalView",
  "modules/shared/sortableList/sortableListModule",
  "modules/authoringAdmin/categories/category/topicsUsingCategoryModal/topicsUsingCategoryListModel",
], function (
  Marionette,
  Backbone,
  Messenger,
  _,
  TopicsUsingCategoryModalView,
  SortableListModule,
  TopicsUsingCategoryListModel,
) {
  var TopicsUsingCategoryModalController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "topicsUsingCategoryModal";
      this.namespace = options.namespace;
      this.categoryModel = options.categoryModel;
      this.categoryValueModel = options.categoryValueModel;
    },
    show: function (topicsUsingCategory) {
      this.topicsUsingCategory = topicsUsingCategory;
      var model = new Backbone.Model({
        deletingCategory: this.categoryModel,
        deletingCategoryValue: this.categoryValueModel,
      });
      this.layout = new TopicsUsingCategoryModalView.topicsUsingCategoryModalLayout({
        model: model,
      });
      let headers = Messenger.reqres.request("topics:using:category:headers");
      this.topicsUsingCategoryList = this.addSubModule(
        new SortableListModule({
          region: this.layout.topicsUsingCategoryList,
          headers: headers,
          hideControls: true,
          namespace: this.namespace,
        }),
      );

      this.layout.on(
        "done",
        function () {
          // At this point we know there is at least one topic using the category code.
          // Open a message dialog and ask user to confirm deletion of category code.
          if (this.categoryModel) {
            Messenger.yesNoDialog(
              "admin.categories.deleteCategoryFromTopics",
              {
                yes: () => {
                  Messenger.vent.trigger("track:interaction", {
                    action: "Delete Category",
                    id: this.categoryModel.id,
                    idType: "Category",
                    object: "Category",
                    source: "Topics using Category",
                  });
                  Messenger.vent.trigger("cancel:textbox"); //cancel any open textboxes
                  Messenger.vent.trigger("delete:category", this.categoryModel); //bubble up event
                  // after deleting, close modal
                  Messenger.vent.trigger("close:modal");
                },
              },
              this,
            );
          } else if (this.categoryValueModel) {
            Messenger.yesNoDialog(
              "admin.categories.deleteCategoryValueFromTopics",
              {
                yes: () => {
                  Messenger.vent.trigger("track:interaction", {
                    action: "Delete Category Value",
                    id: this.categoryValueModel.id,
                    idType: "Category Value",
                    object: "Category Value",
                    source: "Topics using Category Value",
                  });
                  this.categoryValueModel.deleteModel();
                  Messenger.vent.trigger("cancel:textbox");
                  // after deleting, close modal
                  Messenger.vent.trigger("close:modal");
                },
              },
              this,
            );
          }
        },
        this,
      );

      this.layout.on(
        "cancel",
        function () {
          this.layout.hideError();
          Messenger.vent.trigger("cancel:deleting:category");
          Messenger.vent.trigger("close:modal");
        },
        this,
      );

      this.layout.on(
        "show",
        function () {
          this.layout.hideError();
          this._showSubViews();
        },
        this,
      );

      this.showRegion(this.layout);
    },
    _showSubViews: function () {
      this.topicsUsingCategoryList.show(this.topicsUsingCategory);
    },
  });

  return TopicsUsingCategoryModalController;
});
